export default {
  cancelButton: 'Cancel',
  saveButton: 'Save',
  generalInfo: 'General info',
  activity: 'Last login: ',
  noActivity: 'Last login: -',
  placeholder: {
    firstName: 'First name*',
    middleName: 'Middle name',
    lastName: 'Last name*',
    email: 'Email*',
    type: 'Type',
  },
};
